export default function FinalCTA() {
  const nearbyLinks = [
    { name: "Fargo", href: "/cities/fargo" },
    { name: "Grand Forks", href: "/cities/grand-forks" },
    { name: "Helena", href: "/cities/helena" },
    { name: "North Dakota", href: "/states/north-dakota" },
  ];

  return (
    <footer className="bg-[#1A365D]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Ready to Get Started?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">
            Get Your Bismarck Passport Fast
          </h2>
          <p className="text-white/60 max-w-xl mx-auto text-base leading-relaxed mb-8">
            Don&apos;t let passport delays affect your travel or work schedule. Fast Passport Center delivers in 2–9 days — no Denver or Chicago agency trip required.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
            >
              Start My Passport Now <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line"></i> Call 877-253-0084
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <img
                src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Header.svg"
                alt="Fast Passport Center"
                className="h-8 w-auto brightness-0 invert mb-3"
              />
              <p className="text-white/40 text-xs max-w-xs">
                Registered U.S. Department of State courier service. Serving Bismarck and all of central North Dakota.
              </p>
            </div>
            <div>
              <p className="text-white/40 text-xs mb-3 font-semibold uppercase tracking-wider">Other North Dakota Cities</p>
              <div className="flex flex-wrap gap-2">
                {nearbyLinks.map((l) => (
                  <a
                    key={l.name}
                    href={l.href}
                    className="text-xs text-white/50 hover:text-[#F6C344] transition-colors whitespace-nowrap"
                  >
                    {l.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <p className="text-white/30 text-xs text-center mt-8">
            &copy; {new Date().getFullYear()} Fast Passport Center. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}